module.exports = __webpack_public_path__ + "static/img/baselineRepair_pic06.2c4ab5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baselineRepair/baselineRepair_pic06.png
// module id = 471
// module chunks = 1